
/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AccountDeletionTasks,
  AccountDeletionTasksSearchRequest,
  AccountDeletionWorkflowType,
  ClientIdentityDeletionTaskStats,
  FreelancerAccountDeletionTaskStats,
  SelectionJobTriggerRequest,
  UndefinedAccountDeletionTaskStats,
} from '../models';
import {
    AccountDeletionTasksFromJSON,
    AccountDeletionTasksToJSON,
    AccountDeletionTasksSearchRequestFromJSON,
    AccountDeletionTasksSearchRequestToJSON,
    AccountDeletionWorkflowTypeFromJSON,
    AccountDeletionWorkflowTypeToJSON,
    ClientIdentityDeletionTaskStatsFromJSON,
    ClientIdentityDeletionTaskStatsToJSON,
    FreelancerAccountDeletionTaskStatsFromJSON,
    FreelancerAccountDeletionTaskStatsToJSON,
    SelectionJobTriggerRequestFromJSON,
    SelectionJobTriggerRequestToJSON,
    UndefinedAccountDeletionTaskStatsFromJSON,
    UndefinedAccountDeletionTaskStatsToJSON,
} from '../models';

export interface CancelAccountDeletionTaskRequest {
    deletionTaskId: string;
    workflowType: AccountDeletionWorkflowType;
}

export interface CloneCanceledAccountDeletionTaskRequest {
    deletionTaskId: string;
}

export interface FindAccountDeletionTasksRequest {
    accountDeletionTasksSearchRequest: AccountDeletionTasksSearchRequest;
}

export interface TriggerSelectionJobRequest {
    selectionJobTriggerRequest: SelectionJobTriggerRequest;
}

/**
 * 
 */
export class AccountDeletionTaskApi extends runtime.BaseAPI {

    /**
          */
    async cancelAccountDeletionTaskRaw(requestParameters: CancelAccountDeletionTaskRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['deletionTaskId'] == null) {
            throw new runtime.RequiredError(
                'deletionTaskId',
                'Required parameter "deletionTaskId" was null or undefined when calling cancelAccountDeletionTask().'
            );
        }

        if (requestParameters['workflowType'] == null) {
            throw new runtime.RequiredError(
                'workflowType',
                'Required parameter "workflowType" was null or undefined when calling cancelAccountDeletionTask().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['workflowType'] != null) {
            queryParameters['workflowType'] = requestParameters['workflowType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/account/api/account-deletion-admin/deletion-tasks/{deletionTaskId}`.replace(`{${"deletionTaskId"}}`, encodeURIComponent(String(requestParameters['deletionTaskId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async cancelAccountDeletionTask(requestParameters: CancelAccountDeletionTaskRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelAccountDeletionTaskRaw(requestParameters, initOverrides);
    }

    /**
     * Start a clone of the task, if previously canceled
          */
    async cloneCanceledAccountDeletionTaskRaw(requestParameters: CloneCanceledAccountDeletionTaskRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['deletionTaskId'] == null) {
            throw new runtime.RequiredError(
                'deletionTaskId',
                'Required parameter "deletionTaskId" was null or undefined when calling cloneCanceledAccountDeletionTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/account/api/account-deletion-admin/deletion-tasks/{deletionTaskId}/clone-request`.replace(`{${"deletionTaskId"}}`, encodeURIComponent(String(requestParameters['deletionTaskId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Start a clone of the task, if previously canceled
          */
    async cloneCanceledAccountDeletionTask(requestParameters: CloneCanceledAccountDeletionTaskRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.cloneCanceledAccountDeletionTaskRaw(requestParameters, initOverrides);
    }

    /**
          */
    async findAccountDeletionTasksRaw(requestParameters: FindAccountDeletionTasksRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AccountDeletionTasks>> {
        if (requestParameters['accountDeletionTasksSearchRequest'] == null) {
            throw new runtime.RequiredError(
                'accountDeletionTasksSearchRequest',
                'Required parameter "accountDeletionTasksSearchRequest" was null or undefined when calling findAccountDeletionTasks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<AccountDeletionTasks>({
            path: `/account/api/account-deletion-admin/deletion-tasks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AccountDeletionTasksSearchRequestToJSON(requestParameters['accountDeletionTasksSearchRequest']),
        }, initOverrides);

        if (response._data) { response._data=AccountDeletionTasksFromJSON(response._data); }
        return response;
    }

    /**
          */
    async findAccountDeletionTasks(requestParameters: FindAccountDeletionTasksRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AccountDeletionTasks> {
        const response = await this.findAccountDeletionTasksRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
          */
    async getClientIdentityDeletionStatsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientIdentityDeletionTaskStats>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientIdentityDeletionTaskStats>({
            path: `/account/api/account-deletion-admin/client-identity-deletion-stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientIdentityDeletionTaskStatsFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getClientIdentityDeletionStats(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientIdentityDeletionTaskStats> {
        const response = await this.getClientIdentityDeletionStatsRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getFreelancerAccountDeletionStatsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<FreelancerAccountDeletionTaskStats>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<FreelancerAccountDeletionTaskStats>({
            path: `/account/api/account-deletion-admin/freelancer-account-deletion-stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=FreelancerAccountDeletionTaskStatsFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getFreelancerAccountDeletionStats(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<FreelancerAccountDeletionTaskStats> {
        const response = await this.getFreelancerAccountDeletionStatsRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async getUndefinedAccountDeletionStatsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<UndefinedAccountDeletionTaskStats>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<UndefinedAccountDeletionTaskStats>({
            path: `/account/api/account-deletion-admin/undefined-account-deletion-stats`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=UndefinedAccountDeletionTaskStatsFromJSON(response._data); }
        return response;
    }

    /**
          */
    async getUndefinedAccountDeletionStats(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<UndefinedAccountDeletionTaskStats> {
        const response = await this.getUndefinedAccountDeletionStatsRaw(initOverrides);
        return response._data;
    }

    /**
          */
    async recomputeMonitoringViewsRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/account/api/account-deletion-admin/monitoring-views/recomputation-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
          */
    async recomputeMonitoringViews(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.recomputeMonitoringViewsRaw(initOverrides);
    }

    /**
          */
    async triggerSelectionJobRaw(requestParameters: TriggerSelectionJobRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['selectionJobTriggerRequest'] == null) {
            throw new runtime.RequiredError(
                'selectionJobTriggerRequest',
                'Required parameter "selectionJobTriggerRequest" was null or undefined when calling triggerSelectionJob().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/account/api/account-deletion-admin/selection-job/trigger-request`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SelectionJobTriggerRequestToJSON(requestParameters['selectionJobTriggerRequest']),
        }, initOverrides);

        return response;
    }

    /**
          */
    async triggerSelectionJob(requestParameters: TriggerSelectionJobRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.triggerSelectionJobRaw(requestParameters, initOverrides);
    }

}
